import { Injectable, inject } from '@angular/core';
import { EnvironmentLoaderService } from './environment-loader.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ConnectorLocationResponse,
  ConnectorSearchEvent,
} from 'src/app/features/charging-station-location/charging-station-location-model';
import { PriceChartDataResponse } from 'src/app/features/charging-station-location/connector-list/dialogs/dynamic-price-chart-dialog/dynamic-price-chart.interface';
import { ConnectorQueryResponse, GetConnectorsQueryRequest } from './interfaces/connector.interface';

@Injectable({
  providedIn: 'root',
})
export class ConnectorService {
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private httpClient = inject(HttpClient);

  apiUrl: string;
  apiConnectorsUrl: string;

  constructor() {
    this.apiUrl = `${this.environmentLoaderService.config['serviceBaseUrl']}/api/v1/admin/connector/`;
    this.apiConnectorsUrl = `${this.environmentLoaderService.config['serviceBaseUrl']}/api/v1/admin/connectors/`;
  }

  public setPricePolicy(id: string, connectorIdentifier: string) {
    const request = {
      pricePolicyId: id,
    };
    return this.httpClient.put(`${this.apiUrl}${connectorIdentifier}/PricePolicy`, request);
  }

  public getPriceChartData(connectorIdentifier: string): Observable<PriceChartDataResponse> {
    return this.httpClient.get<PriceChartDataResponse>(`${this.apiConnectorsUrl}${connectorIdentifier}/price-projection`);
  }

  public getConnectorsOnOrganization(
    searchEvent: ConnectorSearchEvent | null,
    serialNumber: string | null = null
  ): Observable<ConnectorLocationResponse[]> {
    const url = `${this.apiUrl}${searchEvent?.organizationId}`;
    let params = new HttpParams();
    if (searchEvent?.query) {
      params = params.append('query', searchEvent.query);
    }
    if (serialNumber) {
      params = params.append('serialNumber', serialNumber);
    }

    return this.httpClient.get<ConnectorLocationResponse[]>(url, {
      params,
    });
  }

  public getConnectors(query: GetConnectorsQueryRequest): Observable<ConnectorQueryResponse> {
    const hasFilter = !!query.locationIdentifier || !!query.chargingStationIdentifier || !!query.connectorIdentifier;

    if (!hasFilter) {
      throw new Error('Either locationIdentifier, chargingStationIdentifier or connectorIdentifier must be provided.');
    }

    let params = new HttpParams().set('page_number', String(query.pageNumber ?? 0)).set('page_size', String(query.pageSize ?? 25));

    if (query.locationIdentifier) {
      params = params.set('location_identifier', query.locationIdentifier);
    }

    if (query.chargingStationIdentifier) {
      params = params.set('charging_station_identifier', query.chargingStationIdentifier);
    }

    if (query.connectorIdentifier) {
      params = params.set('connector_identifier', query.connectorIdentifier);
    }

    return this.httpClient.get<ConnectorQueryResponse>(this.apiConnectorsUrl, { params });
  }
}
